import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router'
import routes from "./router/routes";
import VueApollo from "vue-apollo";
import VueWaypoint from 'vue-waypoint'

import BootstrapVue from 'bootstrap-vue/dist/bootstrap-vue.esm';
import Toast from "vue-toastification";
import "./assets/css/override-toast-notification.scss";

import apolloClient from "./vue-apollo";
import {store} from './store';
import "font-awesome/css/font-awesome.min.css";
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';

Vue.config.productionTip = false
Vue.use(BootstrapVue);
Vue.use(VueRouter);
// Waypoint plugin
Vue.use(VueWaypoint)
Vue.use(VueApollo);

const apolloProvider = new VueApollo({
  defaultClient: apolloClient
});

Vue.component('VueFontawesome', require('vue-fontawesome-icon/VueFontawesome.vue').default);

const options = {
  maxToasts: 2,
  newestOnTop: true
};
Vue.use(Toast, options);

const router = new VueRouter({mode: 'history',routes});

new Vue({
  router,
  store,
  apolloProvider,
  render: h => h(App)
}).$mount('#app');
